/* RESPONSIBLE TEAM: team-phone */

export type FinVoiceVoiceLanguageOptions = {
  value: FinVoiceVoiceLanguage;
  text: string;
};

export type FinVoiceVoiceLanguage = 'en-US' | 'es-ES' | 'fr-FR' | 'ta-IN';

export const FIN_VOICE_VOICE_LANGUAGE_OPTIONS: FinVoiceVoiceLanguageOptions[] = [
  { value: 'en-US', text: 'app.lib.languages.language.en' },
  { value: 'es-ES', text: 'app.lib.languages.language.es' },
  { value: 'ta-IN', text: 'app.lib.languages.language.ta' },
];

export const DEFAULT_VOICE_LANGUAGE = 'en-US';
